<template>
    <SocialAuthBtn
        :img="logo"
        :label="$t('shared.loginModule.socialAuthBtns.continueWithWeChat')"
        color="#00dd6c"
        class="wechat-btn"
        @click="weChatLogIn"
        :tiny="tiny"
    />
</template>

<script>
import WeChatFlow from '~/utils/socialAuth/WeChatFlow';
import SocialAuthBtn from './SocialAuthBtn';

// Assets
import WeChatLogo from '~/assets/img/WeChatLogo.png';

export default {
    name: 'WeChatLogInBtn',
    components: { SocialAuthBtn },
    props: {
        redirectPath: String,
        tiny: Boolean,
    },
    data: () => ({
        logo: WeChatLogo,
    }),
    methods: {
        async weChatLogIn() {
            let queryObject = {
                redirectUrl: this.$interfaces.logInModule.getRedirect() || this.$route.path,
            };

            WeChatFlow.startAuthFlow(this.redirectPath, queryObject, this.$route.query || {});
        },
    },
};
</script>

<style>
.wechat-btn > img {
    margin-right: 30px;
    width: 20px !important;
    height: 20px !important;
}
</style>
